import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGlassWater: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGlassWater"><Path d="M19.5 3.5H4.5L6.5 20.5H17.5L19.5 3.5Z" stroke="currentColor"/><Path d="M5.25 9.49999C9.75 7.76796 14.25 11.2321 18.75 9.49999" stroke="currentColor"/></CentralIconBase>;
});

export default IconGlassWater;
